import moment from "moment";
import tinycolor from "tinycolor2";
import EditMessageIcon from "../../Assets/Icons/outline/message-edit.svg";
import EditMessageWhiteIcon from "../../Assets/Icons/outline/message-edit-white.svg";
import DeleteMessageWhiteIcon from "../../Assets/Icons/outline/message-remove-white.svg";
import DeleteMessageIcon from "../../Assets/Icons/outline/message-remove.svg";
import ScoringIcon from "../../Assets/Icons/outline/24-support.svg";
import ScoringWhiteIcon from "../../Assets/Icons/outline/24-support-white.svg";
import Switch from "../../Components/Switch";
import AdminContext from "../../Services/Admin";
import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";

const DetailTaskModal = ({ getData, data, handleShow }) => {
	const { loading, addMaster } = useContext(AdminContext);
	const [photo, setPhoto] = useState([]);

	const changeStatus = async (project_id, id, evt) => {
		let response = await addMaster(`project/task/${project_id}/status/${id}`, {
			status: evt ? "Completed" : "On Progress",
		});
		if (!response?.message) {
			getData();
			toast.success("Update Status Success");
		}
	};

	useEffect(() => {
		let dataPhoto = [];
		let dataPhotoAll = [];

		data?.task?.map((item) => {
			item?.contributor?.map((subItem) => {
				if (!dataPhotoAll.includes(subItem.m_users_id)) {
					dataPhoto.push(subItem?.user);
				}
				dataPhotoAll.push(subItem.m_users_id);
			});
		});
		setPhoto(dataPhoto);
	}, [data]);

	return (
		<div className="bg-[#E3E3E3] rounded-xl p-4">
			<div
				className={`flex items-center justify-between mb-4 px-5 py-2 rounded-2xl`}
				style={{
					backgroundColor: data?.hex_code,
					color: tinycolor(data?.hex_code)?.isDark() ? " white" : " black",
				}}
			>
				<div className="flex flex-col">
					<div className="font-semibold pb-0 leading-none text-nowrap mb-1">
						{data?.name?.substring(0, 50)}
						{data?.name?.length > 50 && "..."}
					</div>
					<div className="text-sm pt-0 z-30 leading-none text-nowrap mb-1">Client: {data?.client_name}</div>
					<div className="text-sm pt-0 z-30 leading-none text-nowrap mb-1">
						Status: {data?.status} {`${data?.is_open === 1 ? "(Open)" : "(Closed)"}`}
					</div>
					<div className="text-sm pt-0 z-30 leading-none text-nowrap mb-1">
						Relation Project: {data?.project ? data?.project?.name : "-"}
					</div>
					<div className="text-xs pt-0 z-30 leading-none text-nowrap">
						Description: {data?.description?.substring(0, 60)}
						{data?.description?.length > 60 && "..."}
					</div>
				</div>
				<div>
					<div className="flex flex-col">
						<div className="font-semibold">Deadline {moment(data?.end).format("DD/MM/YYYY")}</div>
						<div className="text-sm">{moment(data?.end).fromNow()}</div>
					</div>
					<div className="flex max-w-[250px] overflow-x-hidden">
						{photo?.map(
							(item, index) =>
								item?.photo_file && (
									<img
										key={index}
										alt=""
										src={process.env?.REACT_APP_FILE_URL + "/" + item?.photo_file}
										className="w-[50px] h-[50px] me-2 rounded-full"
									/>
								)
						)}
					</div>
				</div>
			</div>
			<div className="max-h-[500px] overflow-y-auto">
				{data?.task?.map((item, index) => (
					<div
						className={`flex items-center justify-between mb-4 ms-20 px-5 py-2 rounded-2xl`}
						style={{
							backgroundColor: data?.hex_code,
							color: tinycolor(data?.hex_code)?.isDark() ? " white" : " black",
						}}
						key={index}
					>
						<div className="w-full">
							<div className="font-semibold pb-0 leading-none">
								{item?.name?.substring(0, 85)}
								{item?.name?.length > 90 && "..."}
							</div>
							<div className="text-xs pt-0 z-30 leading-none">
								{item?.description?.substring(0, 180)}
								{item?.description?.length > 200 && "..."}
							</div>
							<div className="text-xs pt-0 z-30 leading-none">
								Score:{" "}
								{item?.contributor && item?.contributor[0]?.score
									? item?.contributor?.map((subItem) => subItem?.user?.name + ": " + subItem.score + " | ")
									: "-"}
							</div>
						</div>
						{data?.is_open === 1 && (
							<div className="min-w-[200px] flex items-center justify-end">
								<Switch
									project_id={item?.t_projects_id}
									id={item?.id}
									checkValue="Completed"
									noCheckValue="Click Done"
									value={item?.status === "On Progress" ? false : true}
									changeStatus={changeStatus}
								/>
								<button
									type="button"
									onClick={() => {
										handleShow(item?.id, "update task", data, item);
									}}
									className="mx-2"
								>
									<img
										src={tinycolor(data?.hex_code)?.isDark() ? EditMessageWhiteIcon : EditMessageIcon}
										alt=""
										className="w-[30px] h-[30px]"
									/>
								</button>
								{(localStorage.getItem("role") === "Superadmin" || localStorage.getItem("role") === "Manager") && (
									<button
										type="button"
										onClick={() => {
											handleShow(item?.id, "score", data, item);
										}}
										className="me-2"
									>
										<img
											src={tinycolor(data?.hex_code)?.isDark() ? ScoringWhiteIcon : ScoringIcon}
											alt=""
											className="w-[30px] h-[30px]"
										/>
									</button>
								)}
								{(localStorage.getItem("role") === "Superadmin" ||
									localStorage.getItem("role") === "Manager" ||
									localStorage.getItem("role") === "Lead Designer") && (
									<button
										type="button"
										onClick={() => {
											handleShow(data?.id, "delete", item?.id, "task");
										}}
									>
										<img
											src={tinycolor(data?.hex_code)?.isDark() ? DeleteMessageWhiteIcon : DeleteMessageIcon}
											alt=""
											className="w-[30px] h-[30px]"
										/>
									</button>
								)}
							</div>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

export default DetailTaskModal;
